import { Row } from 'antd'
import styled from 'styled-components'

export const WrapRowJustification = styled(Row)<{ visible: number }>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`
